<div class="chat-page container-fluid py-3">

  <!-- Page Header -->
  <div
    class="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-3 gap-2">
    <div>
      <h4 class="mb-1 fw-bold d-flex align-items-center gap-2">
        <i class="bi bi-chat-dots"></i>
        <strong>Restore Hair Loss & Scalp Clinic</strong> Chat Center
      </h4>
      <p class="mb-0 text-muted">
        Manage patient conversations in real time. Select a thread to view and reply.
      </p>
    </div>

    <div class="d-flex gap-3 align-items-center">
      <!-- Chat Toggle -->
      <div *ngIf="isStaffUser" class="chat-mode-toggle">
        <div class="form-check form-switch">
          <input class="form-check-input" type="checkbox" [checked]="chatMode === 'STAFF'" (change)="toggleChatMode()">
          <label class="form-check-label small fw-semibold">
            {{ chatMode === 'STAFF' ? 'Staff Chat' : 'Patient Chat' }}
          </label>
        </div>
      </div>

      <button type="button" class="btn btn-outline-secondary btn-sm" (click)="loadThreads(threadPage)"
        [disabled]="loadingThreads">
        <i class="bi bi-arrow-clockwise me-1"></i>
        Refresh
      </button>
    </div>
  </div>

  <!-- Error -->
  <div *ngIf="errorMessage" class="alert alert-danger py-2 mb-3">
    {{ errorMessage }}
  </div>

  <div class="row g-3 chat-layout">
    <!-- Threads sidebar -->
    <div class="col-12 col-md-4 col-lg-3 chat-sidebar-col">
      <div class="card h-100 shadow-sm chat-sidebar-card">
        <div class="card-header bg-white border-0 pb-1">
          <div class="d-flex align-items-center justify-content-between mb-2">
            <span class="fw-semibold">
              Messages
              <span class="badge bg-light text-muted ms-1">{{ threadTotal }}</span>
            </span>
          </div>

          <div class="mb-2">
            <div class="input-group input-group-sm">
              <span class="input-group-text bg-light border-end-0">
                <i class="bi bi-search"></i>
              </span>
              <input type="text" class="form-control border-start-0" [placeholder]="
  isPatientUser
    ? 'Search clinic staff...'
    : (isStaffChat() ? 'Search staff...' : 'Search patient...')
" [(ngModel)]="searchText" (keyup.enter)="searchPatients()">
              <button class="btn btn-outline-secondary" type="button" (click)="searchPatients()">
                Go
              </button>
            </div>

            <!-- Patients live search dropdown -->
            <!-- STAFF search results (patients) -->
            <div class="patient-search-results mt-1"
              *ngIf="isStaffUser && isPatientChat() && (searchText || '').trim().length && patients.length">
              <div class="list-group small shadow-sm">
                <button type="button"
                  class="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
                  *ngFor="let p of patients" (click)="startChatWithPatient(p)">
                  <div>
                    <div class="fw-semibold">{{ p.fullName }}</div>
                    <div class="text-muted">{{ p.phone || 'No phone' }}</div>
                  </div>
                  <span class="badge bg-light text-muted">Start chat</span>
                </button>
              </div>
            </div>

            <!-- PATIENT search results (staff contacts) -->
            <div class="patient-search-results mt-1"
              *ngIf="isPatientUser && (searchText || '').trim().length && staffContacts.length">
              <div class="list-group small shadow-sm">
                <button type="button"
                  class="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
                  *ngFor="let u of staffContacts" (click)="selectContact(u)">
                  <div>
                    <div class="fw-semibold">{{ u.fullName }}</div>
                    <div class="text-muted">{{ u.role || 'STAFF' }}</div>
                  </div>
                  <span class="badge" [ngClass]="u.isOnline ? 'bg-success' : 'bg-secondary'">
                    {{ u.isOnline ? 'Online' : 'Offline' }}
                  </span>
                </button>
              </div>
            </div>
          </div>
          <!-- Filters: status + unread as tiny chips -->
          <div *ngIf="isStaffUser"
            class="filters-row d-flex align-items-center gap-2 overflow-auto flex-nowrap pt-1 pb-1">
            <!-- Status filters -->
            <div class="d-flex gap-1">
              <button type="button" class="btn btn-filter-chip" [class.active]="filterStatus === 'ALL'"
                (click)="setFilterStatus('ALL')">
                All
              </button>

              <button type="button" class="btn btn-filter-chip" [class.active]="filterStatus === 'OPEN'"
                (click)="setFilterStatus('OPEN')">
                Open
              </button>

              <button type="button" class="btn btn-filter-chip" [class.active]="filterStatus === 'CLOSED'"
                (click)="setFilterStatus('CLOSED')">
                Closed
              </button>

              <button type="button" class="btn btn-filter-chip" [class.active]="filterStatus === 'ARCHIVED'"
                (click)="setFilterStatus('ARCHIVED')">
                Archived
              </button>
            </div>

            <!-- Small divider -->
            <div class="vr d-none d-md-block mx-1"></div>

            <!-- Unread filters -->
            <div class="d-flex gap-1">
              <button type="button" class="btn btn-filter-chip" [class.active]="filterUnread === 'all'"
                (click)="setFilterUnread('all')">
                All
              </button>

              <button type="button" class="btn btn-filter-chip" [class.active]="filterUnread === 'admin'"
                (click)="setFilterUnread('admin')">
                Unread for me
              </button>

              <button type="button" class="btn btn-filter-chip" [class.active]="filterUnread === 'patient'"
                (click)="setFilterUnread('patient')">
                Unread for patient
              </button>
            </div>
          </div>
        </div>

        <div class="card-body p-0">
          <div class="thread-list-wrapper h-100">

            <!-- Loading -->
            <div *ngIf="loadingThreads" class="text-center py-4">
              <div class="spinner-border spinner-border-sm" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
            </div>

            <!-- Empty -->
            <div *ngIf="isStaffUser && !loadingThreads && !threads.length" class="text-center py-4 text-muted">
              <i class="bi bi-inbox fs-1 d-block mb-2"></i>
              <div>No chat threads yet.</div>
            </div>

            <!-- Thread list -->
            <!-- STAFF: show threads (patients) -->
            <div class="thread-list" *ngIf="isPatientChat() && !loadingThreads && threads.length">
              <button type="button" class="thread-item" *ngFor="let t of threads"
                [class.active]="selectedThread && selectedThread._id === t._id" (click)="selectThread(t)">

                <div class="thread-avatar-wrapper">
                  <div class="thread-avatar">
                    {{ getPatientInitials(t) }}
                  </div>
                  <span class="presence-dot" [ngClass]="isPatientOnline(t) ? 'online' : 'offline'"></span>
                </div>

                <div class="thread-main">
                  <div class="d-flex align-items-center justify-content-between">
                    <div class="thread-title text-truncate">
                      {{ getThreadTitle(t) }}
                    </div>
                  </div>

                  <div class="thread-last text-truncate">
                    <ng-container *ngIf="getLastMessageTickClasses(t) as tickClasses">
                      <i *ngIf="tickClasses.length" [ngClass]="tickClasses"></i>
                    </ng-container>
                    {{ getLastMessagePreview(t) }}
                  </div>
                </div>

                <div class="thread-meta text-end">
                  <div class="text-muted small mb-1">
                    {{ formatTime(t.updatedAt) }}
                  </div>
                  <div *ngIf="t.unreadForAdmin > 0" class="badge bg-success rounded-pill">
                    {{ t.unreadForAdmin }}
                  </div>
                </div>
              </button>
            </div>

            <!-- PATIENT: show staff contacts as left list -->
            <!-- ✅ STAFF CHAT THREADS -->
            <div class="thread-list" *ngIf="isStaffChat() && !loadingThreads && threads.length">

              <button type="button" class="thread-item" *ngFor="let t of threads"
                [class.active]="selectedThread && selectedThread._id === t._id" (click)="selectThread(t)">

                <div class="thread-avatar-wrapper">
                  <div class="thread-avatar">
                    {{ getThreadInitials(t) }}
                  </div>
                </div>

                <div class="thread-main">
                  <div class="d-flex align-items-center justify-content-between">
                    <div class="thread-title text-truncate">
                      {{ getThreadTitle(t) }}
                    </div>
                  </div>

                  <div class="thread-last text-truncate">
                    <ng-container *ngIf="getLastMessageTickClasses(t) as tickClasses">
                      <i *ngIf="tickClasses.length" [ngClass]="tickClasses"></i>
                    </ng-container>

                    {{ getLastMessagePreview(t) }}
                  </div>
                </div>

                <div class="thread-meta text-end">
                  <div class="text-muted small mb-1">
                    {{ formatTime(t.updatedAt) }}
                  </div>

                  <div *ngIf="t.unreadForAdmin > 0" class="badge bg-success rounded-pill">
                    {{ t.unreadForAdmin }}
                  </div>
                </div>

              </button>

            </div>

            <!-- Floating + button -->
            <button *ngIf="isStaffUser && isPatientChat()" type="button" class="btn btn-success btn-new-chat"
              (click)="openPatientSheet()">
              <i class="bi bi-plus-lg"></i>
            </button>

            <!-- ✅ PATIENT SIDE + BUTTON -->
            <button *ngIf="isPatientUser" type="button" class="btn btn-primary btn-new-chat" (click)="openStaffSheet()">
              <i class="bi bi-plus-lg"></i>
            </button>

            <!-- Patient FULL overlay (card ke andar) -->
            <div *ngIf="showPatientSheet" class="patient-sheet-overlay">
              <div class="patient-sheet-backdrop"></div>

              <div class="patient-sheet">
                <div class="patient-sheet-header d-flex align-items-center justify-content-between px-3 pt-2 pb-1">
                  <h6 class="mb-0">Select patient</h6>
                  <button type="button" class="btn btn-sm btn-light" (click)="closePatientSheet()">
                    <i class="bi bi-x-lg"></i>
                  </button>
                </div>

                <div class="patient-sheet-body">
                  <div *ngIf="allPatientsLoading" class="text-center py-3 small text-muted">
                    Loading patients…
                  </div>

                  <div *ngFor="let p of allPatients" class="patient-row" (click)="onPatientRowClick($event, p)">
                    <div class="patient-avatar">
                      {{ getInitials(p.fullName) }}
                    </div>
                    <div class="patient-main">
                      <div class="patient-name text-truncate">
                        {{ p.fullName }}
                      </div>
                      <div class="patient-phone text-muted text-truncate">
                        {{ p.phone || 'No phone' }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- ✅ STAFF SHEET -->
            <div *ngIf="showStaffSheet" class="patient-sheet-overlay">
              <div class="patient-sheet-backdrop"></div>

              <div class="patient-sheet">
                <div class="patient-sheet-header d-flex align-items-center justify-content-between px-3 pt-2 pb-1">
                  <h6 class="mb-0">Select Staff</h6>
                  <button type="button" class="btn btn-sm btn-light" (click)="closeStaffSheet()">
                    <i class="bi bi-x-lg"></i>
                  </button>
                </div>

                <div class="patient-sheet-body">

                  <div *ngIf="allStaffLoading" class="text-center py-3 small text-muted">
                    Loading staff…
                  </div>

                  <div *ngFor="let u of allStaff" class="patient-row" (click)="startChatWithStaff(u)">

                    <div class="patient-avatar">
                      {{ getInitials(u.fullName) }}
                    </div>

                    <div class="patient-main">
                      <div class="patient-name text-truncate">
                        {{ u.fullName }}
                      </div>

                      <div class="patient-phone text-muted text-truncate">
                        {{ u.role || 'STAFF' }}
                      </div>
                    </div>

                    <span class="badge" [ngClass]="u.isOnline ? 'bg-success' : 'bg-secondary'">
                      {{ u.isOnline ? 'Online' : 'Offline' }}
                    </span>

                  </div>

                </div>
              </div>
            </div>

          </div>
        </div>

        <!-- Thread pagination -->
        <div class="card-footer bg-white border-0 pt-2 pb-2" *ngIf="threadTotalPages > 1">
          <div class="d-flex justify-content-between align-items-center">
            <small class="text-muted">
              Page {{ threadPage }} of {{ threadTotalPages }}
            </small>

            <div class="btn-group btn-group-sm">
              <button type="button" class="btn btn-outline-secondary" (click)="loadThreadsPrev()"
                [disabled]="threadPage <= 1 || loadingThreads">
                <i class="bi bi-chevron-left"></i>
              </button>
              <button type="button" class="btn btn-outline-secondary" (click)="loadThreadsNext()"
                [disabled]="threadPage >= threadTotalPages || loadingThreads">
                <i class="bi bi-chevron-right"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Messages panel -->
    <div class="col-12 col-md-8 col-lg-9 chat-main-col">
      <div class="card chat-card h-100 shadow-sm chat-main-card">

        <!-- No thread selected -->
        <div *ngIf="!selectedThread"
          class="h-100 d-flex flex-column align-items-center justify-content-center text-muted p-4">
          <iframe src="https://lottie.host/embed/5de5e2f3-206d-48d4-8835-f5938315edb3/vZ7rLWWb0n.lottie"></iframe>
          <div class="fw-semibold mb-1" *ngIf="!selectedThread">No conversation selected</div>
          <div class="text-center small">
            {{ isPatientUser ? 'Select a staff member from the left to start chatting.' : 'Choose a thread from the left
            panel to start chatting with a patient.' }}
          </div>
        </div>

        <!-- Thread selected -->
        <ng-container *ngIf="selectedThread">
          <!-- Header -->
          <div class="card-header bg-white d-flex flex-wrap align-items-center justify-content-between gap-2">
            <div class="d-flex align-items-center gap-2">
              <h5 class="mb-0 fw-semibold">
                {{ getThreadTitle(selectedThread) }}
              </h5>

              <span class="header-presence-dot" [ngClass]="getHeaderPresenceOnline() ? 'online' : 'offline'">
              </span>

              <span class="small fw-medium" [ngClass]="getHeaderPresenceOnline() ? 'text-success' : 'text-muted'">
                {{ getHeaderPresenceOnline() ? 'Online' : 'Offline' }}
              </span>
            </div>

            <div class="d-flex align-items-center gap-2">

              <!-- Status badge -->
              <span class="badge" [ngClass]="getThreadStatusClass(selectedThread)">
                {{ selectedThread.status }}
              </span>

              <!-- 🔕 MUTE TOGGLE -->
              <button type="button" class="btn btn-call-icon" [class.muted]="isThreadMuted(selectedThread)"
                [disabled]="muteLoading" (click)="toggleThreadMute()" title="Mute / Unmute">

                <i class="bi" [ngClass]="isThreadMuted(selectedThread) ? 'bi-bell-slash-fill' : 'bi-bell-fill'">
                </i>

              </button>

              <!-- 🔥 AUDIO CALL BUTTON -->
              <button type="button" class="btn btn-call-icon" (click)="onAudioCall()">
                <i class="bi bi-telephone-fill"></i>
              </button>

              <!-- 🔥 VIDEO CALL BUTTON -->
              <button type="button" class="btn btn-call-icon" (click)="onVideoCall()">
                <i class="bi bi-camera-video-fill"></i>
              </button>

            </div>
          </div>

          <!-- Messages body -->
          <div class="card-body chat-body bg d-flex flex-column">
            <!-- Loading messages -->
            <div *ngIf="loadingMessages" class="text-center py-3">
              <div class="spinner-border spinner-border-sm" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
            </div>

            <!-- Empty messages -->
            <div *ngIf="!loadingMessages && !(messages).length" class="text-center py-3 text-muted">
              <i class="bi bi-chat-square-dots fs-1 d-block mb-2"></i>
              <div>No messages in this conversation yet.</div>
              <div class="small">Start the conversation by sending a message below.</div>
            </div>

            <!-- Messages list -->
            <div class="messages-container" *ngIf="(messages).length">
              <div class="text-center mb-2">
                <button type="button" class="btn btn-outline-secondary btn-sm" (click)="loadMessagesPrev()"
                  [disabled]="messagesPage <= 1 || loadingMessages">
                  Load previous
                </button>
              </div>

              <div class="messages-list">
                <div *ngFor="let m of (messages)" class="message-row" [ngClass]="{ 'mine': isMine(m) }">

                  <div [ngClass]="messageBubbleClass(m)">

                    <!-- reaction buttons hover par -->
                    <div class="msg-reaction-bar">
                      <button type="button" (click)="react(m, 'LIKE'); $event.stopPropagation()"
                        title="Like">👍</button>

                      <button type="button" (click)="react(m, 'LOVE'); $event.stopPropagation()"
                        title="Love">❤️</button>

                      <button type="button" (click)="react(m, 'LAUGH'); $event.stopPropagation()"
                        title="Laugh">😂</button>

                      <button type="button" (click)="react(m, 'WOW'); $event.stopPropagation()" title="Wow">😮</button>

                      <button type="button" (click)="react(m, 'SAD'); $event.stopPropagation()" title="Sad">😢</button>
                    </div>

                    <div class="msg-text" [ngClass]="messageTextClass(m)">
                      <div *ngIf="m.text">{{ m.text }}</div>

                      <div class="chat-attachment-box mt-2" *ngIf="hasAttachment(m)">
                        <!-- Image -->
                        <a *ngIf="isImageAttachment(m)" [href]="m.attachment.url" target="_blank"
                          class="chat-attachment-link">
                          <img [src]="m.attachment.url" [alt]="getAttachmentName(m)" class="chat-attachment-image" />
                        </a>

                        <!-- Video -->
                        <div *ngIf="isVideoAttachment(m)" class="chat-attachment-video-wrap">
                          <video controls class="chat-attachment-video">
                            <source [src]="m.attachment.url" [type]="m.attachment.mimeType" />
                          </video>
                          <a [href]="m.attachment.url" target="_blank" class="d-block mt-1">
                            {{ getAttachmentName(m) }}
                          </a>
                        </div>

                        <div *ngIf="isAudioAttachment(m)" class="chat-attachment-audio-wrap">
                          <audio controls class="w-100">
                            <source [src]="m.attachment.url" [type]="m.attachment.mimeType" />
                          </audio>
                        </div>

                        <!-- PDF -->
                        <div *ngIf="isPdfAttachment(m)" class="chat-attachment-file">
                          <i class="bi bi-file-earmark-pdf-fill me-2"></i>
                          <a [href]="m.attachment.url" target="_blank">{{ getAttachmentName(m) }}</a>
                        </div>

                        <!-- Other files -->
                        <div
                          *ngIf="!isImageAttachment(m) && !isVideoAttachment(m) && !isAudioAttachment(m) && !isPdfAttachment(m)"
                          class="chat-attachment-file">
                          <i class="bi bi-file-earmark-arrow-down-fill me-2"></i>
                          <a [href]="m.attachment.url" target="_blank">{{ getAttachmentName(m) }}</a>
                        </div>
                      </div>

                      <span class="msg-meta">
                        <span class="msg-time">
                          {{ formatTime(m.createdAt) }}
                        </span>
                        <i *ngIf="isMine(m)" [ngClass]="getMessageTickClasses(m)"></i>
                      </span>
                    </div>

                    <!-- selected reactions bubble ke neeche -->
                    <div class="msg-reaction-view" *ngIf="m.reactions?.length">
                      <span *ngFor="let r of m.reactions">
                        <ng-container [ngSwitch]="r.reaction">
                          <span *ngSwitchCase="'LIKE'">👍</span>
                          <span *ngSwitchCase="'LOVE'">❤️</span>
                          <span *ngSwitchCase="'LAUGH'">😂</span>
                          <span *ngSwitchCase="'WOW'">😮</span>
                          <span *ngSwitchCase="'SAD'">😢</span>
                        </ng-container>
                      </span>
                    </div>

                  </div>
                </div>
              </div>

              <!-- typing indicator -->
              <div class="typing-indicator mt-2" *ngIf="isPartnerTyping">
                <div class="dot"></div>
                <div class="dot"></div>
                <div class="dot"></div>
                <span class="ms-2 small text-muted">Typing…</span>
              </div>
            </div>
          </div>

          <!-- Composer -->
          <div class="card-footer bg-light">
            <form (ngSubmit)="sendMessage()" class="message-composer">
              <!-- Attachment preview only before sending -->
              <div class="composer-attachment-preview" *ngIf="selectedAttachment">
                <button type="button" class="attachment-preview-close" (click)="removeSelectedAttachment()">
                  <i class="bi bi-x-lg"></i>
                </button>

                <!-- image -->
                <div *ngIf="selectedAttachmentType === 'image'" class="attachment-preview-image-wrap">
                  <img [src]="selectedAttachmentPreviewUrl!" [alt]="selectedAttachmentName"
                    class="attachment-preview-image" />
                  <div class="attachment-preview-name">{{ selectedAttachmentName }}</div>
                </div>

                <!-- video -->
                <div *ngIf="selectedAttachmentType === 'video'" class="attachment-preview-video-wrap">
                  <video class="attachment-preview-video" controls>
                    <source [src]="selectedAttachmentPreviewUrl!" [type]="selectedAttachment?.type" />
                  </video>
                  <div class="attachment-preview-name">{{ selectedAttachmentName }}</div>
                </div>

                <div *ngIf="selectedAttachmentType === 'audio'" class="attachment-preview-audio-wrap">
                  <audio controls class="w-100">
                    <source [src]="selectedAttachmentPreviewUrl!" [type]="selectedAttachment?.type" />
                  </audio>
                  <div class="attachment-preview-name mt-1">{{ selectedAttachmentName }}</div>
                </div>

                <!-- pdf -->
                <div *ngIf="selectedAttachmentType === 'pdf'" class="attachment-preview-file">
                  <div class="attachment-preview-file-icon pdf">
                    <i class="bi bi-file-earmark-pdf-fill"></i>
                  </div>
                  <div class="attachment-preview-file-meta">
                    <div class="attachment-preview-name">{{ selectedAttachmentName }}</div>
                    <div class="attachment-preview-sub">PDF document</div>
                  </div>
                </div>

                <!-- other -->
                <div *ngIf="selectedAttachmentType === 'file'" class="attachment-preview-file">
                  <div class="attachment-preview-file-icon">
                    <i class="bi bi-file-earmark-fill"></i>
                  </div>
                  <div class="attachment-preview-file-meta">
                    <div class="attachment-preview-name">{{ selectedAttachmentName }}</div>
                    <div class="attachment-preview-sub">Attachment ready to send</div>
                  </div>
                </div>

                <div class="attachment-preview-actions mt-2">
                  <button type="submit" class="btn btn-primary btn-sm" [disabled]="isSending">
                    <i class="bi bi-send-fill me-1"></i>
                    Send
                  </button>

                  <button type="button" class="btn btn-outline-secondary btn-sm ms-2"
                    (click)="removeSelectedAttachment()">
                    <i class="bi bi-x-circle me-1"></i>
                    Cancel
                  </button>
                </div>
              </div>
              <!-- TOP ROW: emoji + attach + input + send/mic -->
              <div class="composer-inner">

                <!-- 😀 EMOJI BUTTON -->
                <button type="button" class="btn-composer-icon" (click)="toggleEmojiPicker()">
                  <i class="bi bi-emoji-smile"></i>
                </button>

                <!-- 📎 ATTACH FILE BUTTON -->
                <button type="button" class="btn-composer-icon" (click)="fileInput.click()">
                  <i class="bi bi-paperclip"></i>
                </button>

                <!-- HIDDEN FILE INPUT -->
                <input #fileInput type="file" hidden (change)="onFilesSelected($event)" />

                <!-- TEXTAREA -->
                <textarea class="form-control" rows="1" placeholder="Type a message..." [(ngModel)]="messageText"
                  name="messageText" (input)="onMessageInputChange()" [disabled]="isSending || loadingMessages">
                </textarea>

                <div class="voice-recording-bar mt-2" *ngIf="isRecordingVoice">
                  <div class="d-flex align-items-center justify-content-between gap-2">
                    <div class="d-flex align-items-center gap-2 text-danger fw-semibold">
                      <span class="record-dot"></span>
                      Recording...
                      <span>{{ formatRecordingTime(recordingSeconds) }}</span>
                    </div>

                    <div class="d-flex align-items-center gap-2">
                      <button type="button" class="btn btn-sm btn-outline-danger" (click)="cancelVoiceRecording()">
                        Cancel
                      </button>

                      <button type="button" class="btn btn-sm btn-danger" (click)="stopVoiceRecording()">
                        Stop
                      </button>
                    </div>
                  </div>
                </div>

                <!-- RIGHT SIDE: SEND vs MIC -->

                <!-- ✉️ SEND BUTTON (agar text hai) -->
                <button *ngIf="messageText.trim() || selectedAttachment" type="submit" class="btn btn-primary btn-send"
                  [disabled]="isSending">
                  <ng-container *ngIf="!isSending">
                    <i class="bi bi-send-fill"></i>
                  </ng-container>
                  <span *ngIf="isSending" class="spinner-border spinner-border-sm"></span>
                </button>

                <!-- 🎙️ MIC BUTTON (agar text empty hai) -->
                <button *ngIf="!messageText.trim() && !selectedAttachment" type="button"
                  class="btn-composer-icon btn-mic" [class.recording]="isRecordingVoice" (click)="onMicClick()">

                  <i class="bi" [ngClass]="isRecordingVoice ? 'bi-stop-fill' : 'bi-mic-fill'"></i>
                </button>
              </div>

              <!-- BOTTOM: EMOJI PICKER GRID -->
              <div class="emoji-picker" *ngIf="showEmojiPicker">
                <button type="button" class="emoji-btn" *ngFor="let e of emojis" (click)="appendEmoji(e)">
                  {{ e }}
                </button>
              </div>

            </form>
          </div>
        </ng-container>

      </div>
    </div>
  </div>
</div>




<!-- =========================
     CALL UI OVERLAY (WhatsApp style)
========================= -->
<div class="call-overlay" *ngIf="isInCallUI">
  <div class="call-box">

    <audio #remoteAudio autoplay playsinline></audio>

    <!-- top -->
    <div class="call-top">
      <div class="call-avatar">
        {{ getInitials(getThreadTitle(selectedThread!)) }}
      </div>

      <div class="call-info">
        <div class="call-name">{{ getThreadTitle(selectedThread!) }}</div>
        <div class="call-sub">
          <ng-container *ngIf="currentCall?.type === 'VIDEO'; else audioLbl">
            Video call
          </ng-container>
          <ng-template #audioLbl>Audio call</ng-template>

          <span class="dot">•</span>

          <span *ngIf="currentCall?.status === 'RINGING'">Ringing…</span>
          <span *ngIf="currentCall?.status === 'ACCEPTED'">Connected</span>
        </div>

        <div class="call-timer" *ngIf="callSeconds > 0 && currentCall?.status === 'ACCEPTED'">
          {{ formatCallTime(callSeconds) }}
        </div>
      </div>
    </div>

    <!-- middle (only for VIDEO) -->
    <div class="call-media" *ngIf="currentCall?.type === 'VIDEO'">
      <video #remoteVideo autoplay playsinline></video>
      <video #localVideo autoplay muted playsinline></video>
    </div>

    <!-- controls -->
    <div class="call-controls">
      <button class="btn-call-control" type="button" (click)="toggleMuteMic()">
        <i class="bi" [ngClass]="isMicMuted ? 'bi-mic-mute-fill' : 'bi-mic-fill'"></i>
      </button>

      <button class="btn-call-control danger" type="button" (click)="endCall()">
        <i class="bi bi-telephone-x-fill"></i>
      </button>

      <button class="btn-call-control" type="button" *ngIf="currentCall?.type === 'VIDEO'" (click)="toggleCamera()">
        <i class="bi" [ngClass]="isCamOff ? 'bi-camera-video-off-fill' : 'bi-camera-video-fill'"></i>
      </button>
    </div>
  </div>
</div>

<!-- =========================
     INCOMING CALL MODAL
========================= -->
<div class="incoming-overlay" *ngIf="incomingCall && !isInCallUI">
  <div class="incoming-box">
    <div class="incoming-title">Incoming {{ incomingCall.type === 'VIDEO' ? 'Video' : 'Audio' }} Call</div>

    <div class="incoming-name">
      {{ getIncomingCallerText() }}
    </div>

    <div class="incoming-actions">
      <button type="button" class="btn-incoming reject" (click)="rejectIncomingCall()">
        <i class="bi bi-telephone-x-fill me-1"></i> Reject
      </button>
      <button type="button" class="btn-incoming accept" (click)="acceptIncomingCall()">
        <i class="bi bi-telephone-fill me-1"></i> Accept
      </button>
    </div>
  </div>
</div>